var axios = require('axios')
var uuid = require('uuid')
// const notificationUrl = process.env.host + '/' + process.env.version_fe + '/' + process.env.prefix_notification
// const notificationUrlV1 = process.env.host + '/' + process.env.version + '/' + process.env.prefix_notification
const notificationUrlV4 = process.env.host + '/' + process.env.version_v4 + '/' + process.env.prefix_notification

// Get list email templates
axios.getEmailTemplateList = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/templates?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Get list email template types
axios.getEmailTypeList = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/email-types')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

/**
 *  Get Email Template detail
 *
 * @param params
 * @param success
 * @param callBackError
 */
axios.getEmailTemplateDetail = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/templates?id=' + params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createEmailTemplate = function (params, success, callBackError, attributes = {}) {
  axios.defaults.headers.common['x-user-email'] = attributes.email || '?'
  this.post(notificationUrlV4 + '/email-templates/templates', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateEmailTemplate = function (params, success, callBackError, attributes = {}) {
  delete params['client_id']
  delete params['created_at']
  delete params['updated_at']
  delete params['email_type']
  axios.defaults.headers.common['x-user-email'] = attributes.email || '?'
  this.put(notificationUrlV4 + '/email-templates/templates', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Get list of email templates triggers
axios.getEmailTemplateTriggersList = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/email-mappings?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Get email template trigger details
axios.getEmailTemplateTriggerDetails = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/email-mappings?uuid=' + params.uuid)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Create email template trigger
axios.createEmailTemplateTrigger = function (params, success, callBackError, attributes = {}) {
  axios.defaults.headers.common['x-user-email'] = attributes.email || '?'
  this.post(notificationUrlV4 + '/email-templates/email-mappings', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Update email template trigger
axios.updateEmailTemplateTrigger = function (params, success, callBackError, attributes = {}) {
  axios.defaults.headers.common['x-user-email'] = attributes.email || '?'
  this.put(notificationUrlV4 + '/email-templates/email-mappings', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Delete email template trigger
axios.deleteEmailTemplateTrigger = function (params, success, callBackError, attributes = {}) {
  axios.defaults.headers.common['x-user-email'] = attributes.email || '?'
  this.delete(notificationUrlV4 + `/email-templates/email-mappings?uuid=${params.uuid}&name=${params.name}`)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Preview email
axios.previewEmailTemplateTrigger = function (params, success, callBackError) {
  this.post(notificationUrlV4 + '/email/event', params, {
    headers: {
      'Content-Type': 'application/json',
      'Request-Identifier': uuid(),
      'X-Api-Key': process.env.event_enqueue_notification_v4_api_key
    }
  })
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && (
        error.response.status == 400 ||
        error.response.status == 500 ||
        error.response.status == 401)) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Get list of email templates versions
axios.getEmailTemplateVersions = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/versions?id=' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// Get email template version details
axios.getEmailTemplateVersionDetails = function (params, success, callBackError) {
  this.get(notificationUrlV4 + '/email-templates/versions?id=' + params.id + '&version_id=' + params.version)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Notification.js